module.exports = __webpack_public_path__ + "img/pl.c01d3a5b.png";